export * from './descSlice.pipe'
export * from './yesno.pipe'